import type { ReactNode } from 'react';

import IllustratedEmptyState from './IllustratedEmptyState';

export default function DisplayNoResult({ message, children }: { message: ReactNode; children?: ReactNode }) {
  return (
    <IllustratedEmptyState
      imageSrc="svg/NoSearchResult_ez_transparent.svg"
      imageAlt="not_found"
      imageDataQaElementId="no_result_image"
      message={message}
      messageDataQaElementId="no_result_text"
    >
      {children}
    </IllustratedEmptyState>
  );
}
